import { Id } from '../../models/id';
import { mailingHousesUrl } from '../../urls';

export const viewMailingHouseUrl = (mailingHouseId: Id) =>
  `${mailingHousesUrl()}/${mailingHouseId}`;

export const createMailingHouseUrl = () => `${mailingHousesUrl()}/create`;
export const editMailingHouseUrl = (mailingHouseId: Id) =>
  `${viewMailingHouseUrl(mailingHouseId)}/edit`;
